import { render } from "./ParadigmUN.vue?vue&type=template&id=d511e788&scoped=true&ts=true"
import script from "./ParadigmUN.vue?vue&type=script&lang=ts"
export * from "./ParadigmUN.vue?vue&type=script&lang=ts"

import "./ParadigmUN.vue?vue&type=style&index=0&id=d511e788&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d511e788"]])

export default __exports__